import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { Modal } from 'react-bootstrap';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffProcessTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      process_documents: '',
      aircraft_models: null,
      staff_processes: [],
      processes_list: null,
      process_subtypes_list: [],
      process_subtype_documents: [],
      process_subtype_id: '',
      aircraft_model_id: '',
      date_start: '',
      expiration: '',
      process_id: '',
      process_selected: 0,
      process_subtype_selected: 0,
      process_modal: {},
      modal: false,
      file_process: '',
    };
    //bind específico
    // this.clearSelects = this.clearSelects.bind(this);
    // this.loadSubtypes = this.loadSubtypes.bind(this);
    // this.loadDocuments = this.loadDocuments.bind(this);
    // this.addProcess = this.addProcess.bind(this);
    // this.ActionsButtons = this.ActionsButtons.bind(this);
    // this.delete = this.delete.bind(this);
    // this.refreshData = this.refreshData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  // handleToggleChange (name, event) {
  //   var change = {};
  //   var data_temp = [];
  //   var self = this;
  //   Object.keys(self.state.process_subtype_documents).map(function(k) {
  //     if("process_documents_" + self.state.process_subtype_documents[k].id === name) {
  //       change = {
  //         checked: event.target.checked,
  //         required: self.state.process_subtype_documents[k].required,
  //         required_str: self.state.process_subtype_documents[k].required_str,
  //         name_slug: self.state.process_subtype_documents[k].name_slug,
  //         name: self.state.process_subtype_documents[k].name,
  //         document_id: self.state.process_subtype_documents[k].document_id,
  //         id: self.state.process_subtype_documents[k].id,
  //       };
  //     } else {
  //       change = {
  //         checked: self.state.process_subtype_documents[k].checked,
  //         required: self.state.process_subtype_documents[k].required,
  //         required_str: self.state.process_subtype_documents[k].required_str,
  //         name_slug: self.state.process_subtype_documents[k].name_slug,
  //         name: self.state.process_subtype_documents[k].name,
  //         document_id: self.state.process_subtype_documents[k].document_id,
  //         id: self.state.process_subtype_documents[k].id,
  //       };
  //     }
  //     data_temp.push(change);
  //   });
  //   this.setState({process_subtype_documents: data_temp});
  // }
  
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }

  // handleSelectChangeProcess(name, event) {   
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, ()=> {
  //       this.clearSelects();
  //     });
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, ()=> {
  //       this.loadSubtypes(event);
  //     });
  //   }
  // }
  
  // handleSelectChangeSubtype(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, ()=> {
  //       this.clearInputs();
  //     });
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, ()=> {
  //       this.loadDocuments(event);
  //     });
  //   }
  // }
  
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_processes) && this.state.loaded === 0) {
      this.setState({
        processes_list: newProps.processes_list,
        periodic_processes: newProps.periodic_processes,
        staff_processes: newProps.staff_processes,
        aircraft_models: newProps.aircraft_models,
        loaded: 1,
      });
    }
  }

  // clearSelects() {
  //   this.setState({process_subtypes_list: []});
  //   this.setState({process_selected: 0});
  // }

  // clearInputs() {
  //   var self = this;
  //   this.setState({process_subtype_selected: 0});
  //   var i;
  //   Object.keys(self.state.process_subtype_documents).map(function(k) {
  //     var element = document.getElementsByClassName(self.state.process_subtype_documents[k].name_slug + "-" + self.state.process_subtype_documents[k].id);
  //     for (i = 0; i < element.length; i++) {
  //       element[i].parentNode.removeChild(element);    
  //     }      
  //   });
  //   this.setState({process_subtype_documents: []});
  // }

  
  // refreshData (event) {
  //   var self = this;
  //   self.clearInputs();
  //   self.clearSelects();
  //   var header = this.refs.request_api.header('application/json');
  //   Promise.resolve(header).then(function(value) {
  //     var url = config.get('api') + '/funcionario/processos/' + self.props.staff_id;
  //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.setState({staff_processes: responseJson.data});
  //     }).then(() => {
  //       self.props.handleAlert(event.message, event.status, 'open');
  //     });
  //   });
  // }

  export(event) {
    var url = event.currentTarget.value;
    window.open(config.get('cdn') + url);       
  }

  
  // loadSubtypes(event) {
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   this.props.handleAlert('', '', 'open');
  //   Promise.resolve(header).then(function(value) {
  //     var url = config.get('api') + '/processo/subtipos/lista/' + event.value;
  //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'url');
  //       if (responseJson.status === 'success') {
  //         self.setState({process_subtypes_list: responseJson.data});
  //         self.setState({process_selected: 1});
  //       }
  //       window.setTimeout(function(){ self.props.handleAlert('', '', 'closed'); }, 650);
  //     });
  //   });
  // }
  
  // loadDocuments(event) {
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   this.props.handleAlert('', '', 'open');
  //   Promise.resolve(header).then(function(value) {
  //     var url = config.get('api') + '/processo/subtipos/documentos/' + event.value;
  //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'url');
  //       if (responseJson.status === 'success') {
  //         self.setState({process_subtype_documents: responseJson.data});
  //         self.setState({process_subtype_selected: 1});
  //       }
  //       window.setTimeout(function(){ self.props.handleAlert('', '', 'closed'); }, 650);
  //     });
  //   });
  // }

  // addProcess(event) {
  //   var self = this;
  //   event.preventDefault();
  //   var data = new FormData();
  //   var file = document.querySelector(".input-file-process").files[0];
  //   var documents = JSON.stringify(this.state.process_subtype_documents);
  //   data.append("file_process", file);
  //   data.append("process_id", this.state.process_id);
  //   data.append("process_subtype_id", this.state.process_subtype_id);
  //   data.append("aircraft_model_id", this.state.aircraft_model_id);
  //   data.append("date_start", this.state.date_start);
  //   data.append("expiration", this.state.expiration);
  //   data.append("staff_id", this.props.staff_id);
  //   data.append("process_subtype_documents", documents);
  //   var header = this.refs.request_api.header();
  //   this.props.handleAlert('', '', 'open');
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api') + '/funcionario/processo', {
  //       method: 'POST',
  //       mode: 'cors',
  //       headers: value,
  //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData(responseJson);
  //         } else {
  //           self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //         }
  //       }).catch((error) => {
  //       console.error(error);
  //     });
  //   });   
  // }
  // // Fetch deletando um item
  // delete(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/processo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData(responseJson);
  //         } else {
  //           self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //         }
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }


  // ActionsButtons (cell, row) { 
  //   var botao = (
  //     <div className="btn-group">
  //       <button className="btn btn-sm btn-success" onClick={this.export} value={'/files/staff_processes/' + row.archive}>
  //         <i className="fa fa-fw fa-download"></i>
  //       </button>
  //       <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
  //         <i className="fa fa-fw fa-trash"></i>
  //       </button>
  //     </div>
  //   );

  //   return botao;
  // }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {/* <h3 className="page-title">Cadastrar processo</h3>
  <hr/>
  <form onSubmit={this.addProcess}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data de emissão:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Data de validade:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Frota:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_id"
          value={this.state.aircraft_model_id}
          required
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
          options={this.state.aircraft_models}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Processo:</label>
        <Select
          className="form-field-name"
          name="process_id"
          value={this.state.process_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChangeProcess.bind(this, 'process_id')}
          options={this.state.processes_list}
        />    
      </div>
    </div>
    {this.state.process_selected === 0 ? "" : 
      <div className="row">
        <div className="col-md-6 form-group">
          <label>Subtipo:</label>
          <Select
            className="form-field-name"
            name="process_subtype_id"
            value={this.state.process_subtype_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChangeSubtype.bind(this, 'process_subtype_id')}
            options={this.state.process_subtypes_list}
          />    
        </div>
        {self.state.process_subtype_selected === 0 ? "" : 
          <div className="col-md-6 form-group">
            <div className="form-group">
              <label>Arquivo de processos(FILE DIGITAL):</label>
            <input type="text" required type="file" name="file_process" className="form-control input-file-process" placeholder="Arquivo" value={this.state.file_process} onChange={this.handleChange.bind(this, 'file_process')} />
            </div>
          </div>
        }   
      </div>
    }
    {self.state.process_subtype_selected === 0 ? "" : 
      <div className="row">
        {Object.keys(self.state.process_subtype_documents).map(function(k) {
          return (
            <div className="col-md-4">
              <div className="form-group">
                <label>{self.state.process_subtype_documents[k].required === 1 ? self.state.process_subtype_documents[k].name + ":*" : self.state.process_subtype_documents[k].name + ":"}</label>
                <br/>
                {self.state.process_subtype_documents[k].required === 1 ? 
                  <Toggle
                    required
                    aria-label=''
                    name={"process_documents_" + self.state.process_subtype_documents[k].id}
                    onChange={self.handleToggleChange.bind(self, "process_documents_" + self.state.process_subtype_documents[k].id)} />
                  : 
                  <Toggle
                    aria-label=''
                    name={"process_documents_" + self.state.process_subtype_documents[k].id}
                    onChange={self.handleToggleChange.bind(self, "process_documents_" + self.state.process_subtype_documents[k].id)} />
                }
              </div>
            </div>
          );
        })}
      </div>
    }
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <button type="submit" disabled={self.state.process_subtype_selected === 0 ? "disabled" : ""} className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> Adicionar processo</button>
        </div>
      </div>
    </div>
  </form>
  <hr/> */}
  <h3 className="page-title">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tituloProcessos}</h3>
  <hr/>
  <BootstrapTable data={self.state.staff_processes} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.semArquivosDeProcessos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
    <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Frota}</TableHeaderColumn>
    <TableHeaderColumn dataField="process" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Processo}</TableHeaderColumn>
    <TableHeaderColumn dataField="process_subtype" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Subtipo}</TableHeaderColumn>
    <TableHeaderColumn isKey={true} dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.DataDeEmissao}</TableHeaderColumn>
    <TableHeaderColumn dataField="expiration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Validade}</TableHeaderColumn>
    {/* <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={self.ActionsButtons} width='200'>Ações</TableHeaderColumn> */}
  </BootstrapTable>
</div>
    );
  }
}

export default StaffProcessTab;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/Elements/StaffProcessTab.js